module.exports = __webpack_public_path__ + "static/img/icon-switch-tiktok.328a5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/icon-switch-tiktok.png
// module id = n4cT
// module chunks = 156